
import React, { useState,useEffect} from 'react';
import { Link,useLocation } from 'react-router-dom';
import axios from 'axios';

const Studentform = () => {
 
  const [formData, setFormData] = useState({
    studentName: "",
    phoneNumber: "",
    email: "",
    aadharNumber: "",
    address: "",
    district: "",
    taluk: "",
    password: "",
    referralid: localStorage.getItem('UserId'),
    RetypePassword: "",
  });

  const [errorMessage, setErrorMessage] = useState('');
  const [successMessage, setSuccessMessage] = useState('');
 
  const [otp, setOtp] = useState('');
  const [requestId, setRequestId] = useState('');
  const [orderId, setOrderId] = useState('');
  const [message, setMessage] = useState('');
  const [loading, setLoading] = useState(false);
  const [isOtpVerified, setIsOtpVerified] = useState(false);
  const [districts, setDistricts] = useState([]);
  const [talukas, setTalukas] = useState([]);
  const [referralLink, setReferralLink] = useState('');
  const location = useLocation();

useEffect(() => {
  const queryParams = new URLSearchParams(location.search);
  const referralFromUrl = queryParams.get('referralid');
  
  if (referralFromUrl) {
    localStorage.setItem('UserId', referralFromUrl);
    setFormData(prev => ({ ...prev, referralid: referralFromUrl }));
  } else {
    setFormData(prev => ({ ...prev, referralid: localStorage.getItem('UserId') || '' }));
  }
}, [location.search]);



useEffect(() => {
  const userId = localStorage.getItem('UserId');
  if (userId) {
    setReferralLink(`https://ramjitrust.org/studentform?referralid=${userId}`);
  }
}, []);




  useEffect(() => {
    fetch(`${process.env.REACT_APP_API}/locations/districts`)
      .then((res) => res.json())
      .then((data) => setDistricts(data))
      .catch((err) => console.error("Error fetching districts:", err));
  }, []);

  useEffect(() => {
    const selectedDistrict = districts.find(
      (d) => d.name === formData.district
    );

    if (selectedDistrict?.id) {
      fetch(
        `${process.env.REACT_APP_API}/locations/taluks?district_id=${selectedDistrict.id}`
      )
        .then((res) => res.json())
        .then((data) => setTalukas(data))
        .catch((err) => console.error("Error fetching taluks:", err));
    } else {
      setTalukas([]);
    }
  }, [formData.district, districts]);

  const sendmail = async (userId, password, email) => {
    try {
      await axios.post(`${process.env.REACT_APP_API}/adddetails/sendmail`, {
        userId,
        password,
        email
      });
    } catch (error) {
      console.error('Error sending email:', error.response?.data?.message || error.message);
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (formData.password !== formData.RetypePassword) {
      setErrorMessage('Passwords do not match.');
      return;
    }

    const viewPass = false;

    try {
      // Include Aadhaar number in the data sent to the backend
      const response = await axios.post(`${process.env.REACT_APP_API}/adddetails/addstudentform`, { 
        ...formData, 
        // aadhaarNumber, // Send Aadhaar number along with the rest of the data
        viewPass 
      });
      // console.log(aadhaarNumber)
      // console.log(response)

      const { userId, password, email } = response.data;
      // sendmail(userId, password, email);

      setFormData({
        studentName: '',
    phoneNumber: '',
    email: '',
    aadharNumber:'',
    address: '',
    password: '',
    referralid: '',
    RetypePassword: '',
      });

      setErrorMessage('');
      alert('Form submitted successfully!');
      window.location.reload();
    } catch (error) {
      setErrorMessage(error.response?.data?.message || 'Error submitting the form.');
      console.error('Error submitting the form:', error);
    }
  };
    
console.log("formData after update:", formData);



  // const handleChange = (e) => {
  //   const { id, value } = e.target;
  //   setFormData((prevData) => ({
  //     ...prevData,
  //     [id]: value,
  //   }));
  // };
 
  const handleChange = (e) => {
  const { id, value } = e.target;

  // Remove spaces only for password fields
  const newValue =
    id === 'password' || id === 'RetypePassword'
      ? value.replace(/\s/g, '')
      : value;

  setFormData((prevData) => ({
    ...prevData,
    [id]: newValue,
  }));
};

  const validateAadhaar = (number) => /^\d{12}$/.test(number);
  const sendOtp = async (e) => {
    e.preventDefault();
  
    const aadhaarNum = formData.aadharNumber;
  
    if (!validateAadhaar(aadhaarNum)) {
      alert('Invalid Aadhaar number. Please enter a 12-digit number.');
      return;
    }
  
    setLoading(true);
  
    try {
      const generatedOrderId = `ORDER_${new Date().getTime()}`;
      setOrderId(generatedOrderId);
  
      const response = await axios.post(`${process.env.REACT_APP_API}/send/send-otp`, {
        aadhaarNumber: aadhaarNum,
        orderid: generatedOrderId,
      });
  
      setRequestId(response.data.ref_id);
      setMessage('OTP sent to your registered mobile number.');
    } catch (error) {
      if (error.response?.status === 409) {
        alert('Aadhaar number already registered.');
      } else {
        setMessage(error.response?.data?.message || 'Failed to send OTP. Please try again.');
      }
    } finally {
      setLoading(false);
    }
  };
  
  const verifyOtp = async (e) => {
    e.preventDefault();

    if (!otp || !requestId) {
      alert('Please enter OTP first');
      return;
    }

    setLoading(true);

    try {
      const response = await axios.post(`${process.env.REACT_APP_API}/verify/verify-otp`, {
        otp,
        ref_id: requestId,
        orderid: orderId,
        aadhaar_number: formData.aadharNumber,
      });

      const userDetails = response.data.data || {};
      setFormData(prev => ({
        ...prev,
        studentName: userDetails.name || '',
        address: userDetails.address || '',
        phoneNumber: userDetails.phone || '',
      }));

      setMessage('Aadhaar verification successful!');
      setIsOtpVerified(true);
    } catch (error) {
      setMessage(error.response?.data?.message || 'Failed to verify OTP. Please try again.');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div>
      <div style={{ marginBottom: '50px' }}>
        <Link to="/" className="logo_image">
          <img
            src="assets/headimg.jpg"
            alt="Cleenhearts HTML"
            style={{ width: '100%' }}
          />
        </Link>
      </div>
     <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center' ,marginBottom:'10px'}}>
 <button
  onClick={() => {
    navigator.clipboard.writeText(referralLink);
    alert('Referral link copied to clipboard!');
  }}
  style={{
    backgroundColor: '#007bff',
    color: 'white',
    padding: '10px 20px',
    fontSize: '16px',
    border: 'none',
    borderRadius: '8px',
    cursor: 'pointer',
    boxShadow: '0 4px 6px rgba(0, 0, 0, 0.1)',
    transition: 'background-color 0.3s ease'
  }}
  onMouseOver={(e) => (e.target.style.backgroundColor = '#0056b3')}
  onMouseOut={(e) => (e.target.style.backgroundColor = '#007bff')}
>
  Share Referral Link
</button>

</div>


      <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
       

    <div style={{ display: 'flex', flexDirection: 'column', gap: '10px', width: '100%', maxWidth: '400px', margin: '0 auto' }}
    >
    {!isOtpVerified ? (
                  // renderAadhaarVerification()
                   <form 
                   onSubmit={sendOtp} 
                  // onSubmit={()=>setIsOtpVerified(true)}
                   style={{ display: 'flex', flexDirection: 'column', gap: '10px', width: '100%', maxWidth: '400px', margin: '0 auto' }}>
                   <h4>Aadhaar Verification</h4>
                   <input type="text" id="aadharNumber"  placeholder="Enter Aadhaar Number" value={formData.aadharNumber} onChange={handleChange} maxLength={12} className="form-one__control__input"/> 

                   <button type="submit" disabled={loading} className='cleenhearts-btn' style={{width:'50%'}}>
                     {loading ? 'Sending OTP...' : 'Send OTP'}
                   </button>
             
                   {requestId && (
                     <>
                       <input
                         type="text"
                         placeholder="Enter OTP"
                         value={otp}
                         onChange={(e) => setOtp(e.target.value)}
                          className="form-one__control__input"
                       />
                       <button className='cleenhearts-btn' onClick={verifyOtp} disabled={loading} style={{width:'50%'}}>
                         {loading ? 'Verifying...' : 'Verify OTP'}
                       </button>
                     </>
                   )}
                   {message && <p style={{ color: 'green' }}>{message}</p>}
                 </form>
                ) : (
                  <>
                  {/* <form className="login-page__form__box form-one" onSubmit={handleSubmit} style={{ display: 'flex', flexDirection: 'column', gap: '10px', width: '100%' }}>
                    <input type="text" id="studentName" placeholder="Student Name" value={formData.studentName} onChange={handleChange} className="form-one__control__input" readOnly/>
                    <input type="text" id="phoneNumber" placeholder="Phone Number" maxLength={10} value={formData.phoneNumber} onChange={(e) => {
                      const newValue = e.target.value.replace(/[^0-9]/g, '');
                      setFormData(prevData => ({ ...prevData, phoneNumber: newValue }));
                    }} className="form-one__control__input" />
                    <input type="email" id="email" placeholder="Email" value={formData.email} onChange={handleChange} className="form-one__control__input" />
   
                    <textarea id="address" placeholder="Enter your address" value={formData.address || ''} onChange={handleChange} style={{ padding: '8px', width: '100%', minHeight: '80px' }} readOnly/>
                    
                    <input type="password" id="password" placeholder="Password" value={formData.password} onChange={handleChange} className="form-one__control__input" />
                    <input type="password" id="RetypePassword" placeholder="Retype Password" value={formData.RetypePassword} onChange={handleChange} className="form-one__control__input" />

                    <button type="submit" style={{ padding: '15px', backgroundColor: '#007BFF', color: '#fff', border: 'none', cursor: 'pointer', borderRadius: '100px' }}>
                      Register
                    </button>

                    {errorMessage && <p style={{ color: 'red' }}>{errorMessage}</p>}
                    {successMessage && <p style={{ color: 'green' }}>{successMessage}</p>}
                  </form> */}

<form
                    className="login-page__form__box form-one"
                    onSubmit={handleSubmit}
                    style={{
                      display: "flex",
                      flexDirection: "column",
                      gap: "10px",
                      width: "100%",
                    }}
                  >
                    <input
                      type="text"
                      id="studentName"
                      placeholder="Student Name"
                      value={formData.studentName}
                      onChange={handleChange}
                      className="form-one__control__input"
                      readOnly
                    />
                    <input
                      type="text"
                      id="phoneNumber"
                      placeholder="Phone Number"
                      maxLength={10}
                      value={formData.phoneNumber}
                      onChange={(e) => {
                        const newValue = e.target.value.replace(
                          /[^0-9]/g,
                          ""
                        );
                        setFormData((prevData) => ({
                          ...prevData,
                          phoneNumber: newValue,
                        }));
                      }}
                      className="form-one__control__input"
                    />
                    <input
                      type="email"
                      id="email"
                      placeholder="Email"
                      value={formData.email}
                      onChange={handleChange}
                      className="form-one__control__input"
                    />


<textarea
                      id="address"
                      placeholder="Enter your address"
                      value={formData.address || ""}
                      onChange={handleChange}
                      style={{
                        padding: "8px",
                        width: "100%",
                        minHeight: "80px",
                      }}
                      readOnly
                    />

                    <select
                      id="district"
                      value={formData.district || ""}
                      onChange={handleChange}
                      className="form-one__control__input"
                    >
                      <option value="">Select District</option>
                      {districts.map((district) => (
                        <option key={district.id} value={district.name}>
                          {district.name}
                        </option>
                      ))}
                    </select>

                    <select
                      id="taluk"
                      value={formData.taluk || ""}
                      onChange={handleChange}
                      className="form-one__control__input"
                      disabled={!formData.district}
                    >
                      <option value="">Select Taluk</option>
                      {talukas.map((taluk) => (
                        <option key={taluk.id} value={taluk.name}>
                          {taluk.name}
                        </option>
                      ))}
                    </select>

               

                    <input
                      type="password"
                      id="password"
                      placeholder="Password"
                      value={formData.password}
                      onChange={handleChange}
                      className="form-one__control__input"
                    />
                    <input
                      type="password"
                      id="RetypePassword"
                      placeholder="Retype Password"
                      value={formData.RetypePassword}
                      onChange={handleChange}
                      className="form-one__control__input"
                    />

                    <button
                      type="submit"
                      style={{
                        padding: "15px",
                        backgroundColor: "#007BFF",
                        color: "#fff",
                        border: "none",
                        cursor: "pointer",
                        borderRadius: "100px",
                      }}
                    >
                      Register
                    </button>

                    {errorMessage && (
                      <p style={{ color: "red" }}>{errorMessage}</p>
                    )}
                    {successMessage && (
                      <p style={{ color: "green" }}>{successMessage}</p>
                    )}
                  </form>
                  </>
                )}
    </div>

      </div>
    </div>
  );
}

export default Studentform;
